<div class="catalog-dashboard-wrapper">
  <div class="section stats-section">
    <h2 class="section-title">{{ statsTitle }}</h2>
    <div class="stats-grid">
      @for (stat of stats; track stat.label) {
        <app-stats-card
          [value]="stat.value"
          [label]="stat.label"
          [variant]="stat.variant || 'primary'"
        />
      }
    </div>
  </div>
  <div class="section activities-section">
    <h2 class="section-title">{{ lastUpdatesTitle }}</h2>
    <div class="activities-list">
      @if (lastUpdates.length > 0) {
        <app-carousel [showDots]="true" [enableSwipe]="true">
          @for (
            lastUpdate of lastUpdates;
            track `${lastUpdate.name}-${lastUpdate.lastUpdatedDate}`
          ) {
            <div class="carousel-slide">
              <app-last-update-card [lastUpdate]="lastUpdate" />
            </div>
          }
        </app-carousel>
      } @else {
        <p class="empty-message">
          This section is currently empty. Once you begin editing {{ entity }}s,
          the latest updates will appear here.
        </p>
      }
    </div>
  </div>
  <div class="section drafts-section">
    <h2 class="section-title">{{ draftsTitle }}</h2>
    <div class="drafts-list">
      @if (drafts.length > 0) {
        <app-carousel [showDots]="true" [enableSwipe]="true">
          @for (
            draft of drafts;
            track `${draft.name}-${draft.lastUpdatedDate}`
          ) {
            <div class="carousel-slide">
              <app-draft-card
                [draft]="draft"
                (continue)="handleContinueDraft($event)"
              />
            </div>
          }
        </app-carousel>
      } @else {
        <p class="empty-message">
          Your {{ entity }} drafts will appear here whenever you save your
          progress without completing the setup.
        </p>
      }
    </div>
  </div>
</div>
